<div
  class="scrollbar-dark flex flex-col bg-neutral-900 rounded-md overflow-y-auto items-stretch justify-start w-full h-full p-2"
>
  @for (log of logs(); track log) {
    <div class="flex flex-row text-xs font-mono font-normal gap-2 items-stretch justify-between">
      <div class="flex flex-row gap-1 items-stretch justify-start">
        <div class="text-yellow-600">{{ log.agent | uppercase }}:</div>
        <div class="text-green-600">{{ log.message_type }} -</div>
        <div>{{ log.message }}</div>
      </div>
      <div class="flex flex-row gap-1 items-stretch justify-end">
        <div class="font-semibold text-neutral-400">{{ log.status }} -</div>
        <div class="text-xs text-neutral-200">{{ log.timestamp | flxLogDateFormat }}</div>
      </div>
    </div>
  }
  @if (logs().length === 0) {
    <div class="flex flex-row text-xs font-mono font-normal gap-2 items-stretch justify-start">
      <div class="text-neutral-400">No logs yet!</div>
    </div>
  }
</div>
